import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { SearchContainerProps } from "../../interfaces/containers";
import Search from "../../pages/Sell/Search";
import { initialFlow, clearSalePost, getIsPlateRepeated, getPlateInfo, setPlate, setVin, cleanPlateRepeated,cleanPlateInfo, getYears } from "../../actions/salePost";
import { reSendValidation, cleanReSendValidation, setLoginRedirection } from "../../actions/auth";

function mapStateToProps(state: SearchContainerProps) {
    return{
        user: state.auth.user,
        plate: state.salePost.plate,
        vin: state.salePost.vin || '',
        fetchingPlateRepeated: state.salePost.fetchingPlateRepeated,
        plateRepeatedStatus: state.salePost.plateRepeatedStatus,
        fetchingPlateInfo: state.salePost.fetchingPlateInfo,
        brand: state.salePost.brands?.selected,
        year: state.salePost.year,
        documents: state.documents,
        reSendValidationFetching: state.auth.reSendValidationFetching,
        isFoundPlate: state.salePost.isFoundPlate,
        years: state.salePost.years,
        vehicleData: state.salePost.vehicleData
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        initialFlow,
        getPlateInfo,
        getIsPlateRepeated,
        cleanPlateRepeated,
        clearSalePost,
        setPlate,
        setVin,
        reSendValidation,
        cleanReSendValidation,
        getYears,
        cleanPlateInfo
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Search);